<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="500">
        <v-card>
            <v-card-title id="heading" class="d-flex justify-space-between">
                <h4>{{ company.company_name }}'s Status</h4>
                <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
            </v-card-title>

            <v-card-text>
                <p class="my-3">Alert! There are consequences for each status.</p>
                <v-select v-model="selectedStatus" :items="statuses" label="Status"/>
            </v-card-text>
            <v-card-actions class="px-4">
                <v-btn color="warning" @click="updateStatus">Submit</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import {ref} from "vue";
import {send} from "@/composables/apiClient";
import {strOperations} from "@/composables/globals";
import {useSnackbarStore} from "@/stores/snackBarStore";

const props = defineProps({
    modelValue: Boolean,
    company: Object
});
const {showSnackbar} = useSnackbarStore();
const dialogSwitch = ref(props.modelValue);
const selectedStatus = ref(props.company.status);

const statuses = [
    {value: 'enabled', title: 'Enabled'},
    {value: 'disabled', title: 'Disabled'},
    {value: 'restricted', title: 'Restricted'}
];
const emits = defineEmits([
    'update:modelValue',
    'updateStatus'
])

const updateStatus = () => {
    if (confirm(`Are you sure to update status of company "${props.company.company_name}" to ${strOperations().capitalize(selectedStatus.value)}?`)) {
        send('put', `companies/${props.company.id}/status`, {
            status: selectedStatus.value
        })
            .then((response) => {
                if (response.data.success) {
                    emits('updateStatus', {company_id: props.company.id, status: selectedStatus});
                    emits('update:modelValue', false);
                    showSnackbar(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error)
                showSnackbar(`"${props.company.company_name}" Company's status could not be updated`, 'error')
            })
    }
}
</script>
